import React from 'react';
import PropTypes from 'prop-types';

import Collapsible from '../Collapsible';

const Accordion = ({ id, trigger, closeTrigger, closeOnOutsideClick, open, children, onClickCallback }) => (
  <Collapsible
    id={id}
    trigger={trigger}
    closeTrigger={closeTrigger}
    closeOnOutsideClick={closeOnOutsideClick}
    open={open}
    classParentString='accordion'
    onClickCallback={onClickCallback}
  >
    {children}
  </Collapsible>
);

Accordion.defaultProps = {
  open: false,
  children: null,
  closeTrigger: null,
  closeOnOutsideClick: false,
  onClickCallback: null
};

Accordion.propTypes = {
  id: PropTypes.string.isRequired,
  trigger: PropTypes.any.isRequired,
  closeTrigger: PropTypes.any,
  closeOnOutsideClick: PropTypes.bool,
  open: PropTypes.bool,
  children: PropTypes.any,
  onClickCallback: PropTypes.func
};

export default Accordion;
